var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.rootTagName,_vm._b({tag:"Component",staticClass:"website-navigation-nested-item",attrs:{"tabindex":_vm.rootTabIndex,"data-test-id":"navigation-nested-link"}},'Component',_vm.rootAttributes,false),[_c('span',{attrs:{"data-test-id":"navigation-nested-link-text"}},[_vm._v(_vm._s(_vm.transl8(_vm.page.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }